export const settingsRoute = [
  {
    path: "settings",
    element: <p>settings</p>,
  },
];
